// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import { partialRight } from 'lodash'
import { Field } from 'redux-form'
import { AntennaCompanies, AutoSuggest, LabeledInput } from 'components/Form'
import { FeedDirection } from '../components'
import { clearDbSearchForm } from 'redux/modules/databaseSearches'
import { ActionButtons } from '../../common'
import { assignSuggestValue } from './helpers'

import {
  fetchAntennaFamiliesContaining,
  fetchAntennaSpecsByModelNumbersContaining,
} from 'helpers/api'

const af = 'antennaFamily'
const cn = 'companyName'
const mn = 'modelNumber'
const inputRowClass = 'display-flex justify-content-between align-items-start flex-wrap-nowrap'
const liw = {
  width: '12%',
}

const BasicSearch = ({ change, exportResults, hasResults, idRoot, sourceForm }) => (
  <ul className={inputRowClass}>
    <li style={liw}>
      <Field
        autoFocus={true}
        component={LabeledInput}
        id={`${idRoot}antenna-code`}
        label={'Antenna Code'}
        placeholder={'Code'}
        name={'antennaCode'}
        type={'text'} />
    </li>
    <li style={liw}>
      <AntennaCompanies
        handleSelection={partialRight(assignSuggestValue, cn, change)}
        idRoot={idRoot}
        name={cn} />
    </li>
    <li style={liw}>
      <Field
        component={AutoSuggest}
        fetchSuggestions={fetchAntennaFamiliesContaining}
        handleSelection={partialRight(assignSuggestValue, af, change)}
        id={`${idRoot}antenna-model-family`}
        label={`Model Family`}
        name={af}
        optionKey={af} />
    </li>
    <li
      className={'position-relative'}
      style={liw}>
      <Field
        component={AutoSuggest}
        fetchSuggestions={fetchAntennaSpecsByModelNumbersContaining}
        handleSelection={partialRight(assignSuggestValue, mn, change)}
        id={`${idRoot}antenna-model`}
        label={`Antenna Model`}
        name={mn}
        optionKey={null}
        placeholder={'Model'} />
      <FeedDirection idRoot={idRoot} />
    </li>
    <li style={liw}>
      <Field
        component={LabeledInput}
        id={`${idRoot}frequency`}
        label={'Frequency (MHz)'}
        placeholder={'Frequency'}
        name={'frequency'}
        type={'text'} />
    </li>
    <li
      className={`database-search-actions position-relative`}
      style={liw}>
      <ActionButtons
        clearForm={clearDbSearchForm}
        dbSet={'antenna'}
        exportResults={exportResults}
        hasResults={hasResults}
        idRoot={idRoot}
        sourceForm={sourceForm} />
    </li>
  </ul>
)

BasicSearch.propTypes = {
  change: func.isRequired,
  exportResults: func.isRequired,
  hasResults: bool.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default BasicSearch
